<template>
  <v-card style="box-shadow: none" class="px-4">
    <v-row>
      <v-col>
        <v-card style="box-shadow: none">
          <h5>
            {{ $t('message.pages.newLive.totalUniqueViews') }}:
            {{ uniqueViews }} ({{ averageViewsPerMinute }}
            {{ $t('message.pages.newLive.average') }})
          </h5>
        </v-card>
      </v-col>
      <v-col style="border-left: 1px solid rgba(0, 0, 0, 0.12)">
        <v-card style="box-shadow: none">
          <h5>
            {{ $t('message.pages.newLive.totalStreamHours') }}:
            {{ totalStreamHours }} {{ $t('message.pages.newLive.minutes') }}
          </h5>
        </v-card>
      </v-col>
    </v-row>
    <v-card style="box-shadow: none">
      <v-divider class="mt-3"></v-divider>
      <v-row class="pa-6">
        <v-col
          cols="12"
          class="pa-4 pt-0 pb-0 pl-0 d-flex"
          style="position: relative"
        >
          <p class="vertical-text">
            {{ $t('message.views') }}
          </p>
          <apexchart
            :class="{ darkThemeSvgFix: $vuetify.theme.dark }"
            type="area"
            height="250"
            style="width: 100%"
            :options="chartOptions"
            :series="series"
          ></apexchart>
          <span class="horizontal-text">
            {{ $t('message.time') }}
          </span>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { format } from 'date-fns'
import i18n from '@/translations/lang'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  name: 'live-graph',
  props: ['uniqueViews', 'viewsPerMinute'],
  data() {
    let _this = this

    return {
      datePickerShow: false,
      open: false,
      items: '',
      selectedItem: 0,
      series: [
        {
          name: i18n.t('message.views'),
          data: Object.values(_this.viewsPerMinute),
        },
      ],
      estimatedTraffic: 0,
      chartOptions: {
        annotations: {
          xaxis: [],
        },
        chart: {
          toolbar: false,
          type: 'area',
          height: 350,
          zoom: {
            enabled: false,
          },
          offsetX: 0,
          offsetY: 0,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        labels: Object.keys(_this.viewsPerMinute),
        xaxis: {
          type: 'category',
          labels: {
            formatter: function (value) {
              return value
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return value.toFixed(0)
            },
          },
        },
        tooltip: {
          theme: 'dark',
        },
      },
    }
  },
  mounted() {
    this.$vuetify.theme.dark
      ? (this.chartOptions.tooltip.theme = 'dark')
      : (this.chartOptions.tooltip.theme = 'light')
  },
  methods: {
    formatDate(date) {
      if (typeof date === 'object') date = format(date, 'yyyy-MM-dd')
      let splitedDate = date.split('-')
      return `${splitedDate[2]}/${splitedDate[1]}/${splitedDate[0]}`
    },
    formatDateToUS(date) {
      let splitedDate = date.split('-')
      return `${splitedDate[1]}/${splitedDate[2]}/${splitedDate[0]}`
    },
  },
  computed: {
    averageViewsPerMinute() {
      let viewsPerMinute = Object.values(this.viewsPerMinute).reduce(
        (previousValue, currentValue) => {
          return previousValue + currentValue
        },
        0
      )
      let viewsMinutes = Object.values(this.viewsPerMinute).length

      return (viewsPerMinute / viewsMinutes).toFixed(1)
    },
    totalStreamHours() {
      let streamMinutes = Object.keys(this.viewsPerMinute).length - 1
      return streamMinutes
    },
  },
}
</script>
<style lang="scss">
.custom-datepicker {
  .v-date-picker-header__value button {
    font-weight: normal;
  }
  .v-btn {
    font-weight: 400;
  }
}
.datepicker-container {
  .datepicker-item {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 2000;
  }
}

.months-costs {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  min-height: max-content;
}

.bold-text {
  font-weight: 600;
}

.no-traffic-container img {
  height: 14rem;
}

.no-traffic-container p {
  margin-top: -10px;
}

.no-traffic-banner {
  height: 265px;
  padding: 24px;
  width: 100%;
  color: #d6d6d6;
}

.vertical-text {
  left: -65px;
  top: 42%;
  position: absolute;
  transform: rotate(-90deg);
  width: 120px;
}

.horizontal-text {
  position: absolute;
  bottom: 0px;
  left: 48%;
}

.darkThemeSvgFix {
  svg text {
    fill: white;
  }
  .apexcharts-legend-text {
    color: white !important;
  }
}
</style>
